import { createContext } from "react";
import { UploaderFlowProps } from "../hooks/useUploaderFlow";

export const UploaderFlowContext = createContext({} as any);

type ProvidersProps<T extends string> = {
  children: React.ReactNode;
  uploaderFlowValues: Partial<UploaderFlowProps<T>>;
};

export const UploaderFlowProvider = <T extends string>({ children, uploaderFlowValues }: ProvidersProps<T>) => {
  return <UploaderFlowContext.Provider value={uploaderFlowValues}>{children}</UploaderFlowContext.Provider>;
};
